import { USER_INFO } from './types';
import config from 'config';

export default function () {
  return (dispatch, getState) => {
    dispatch(fetchUserInfo(getState().auth));
  };
}

export const fetchUserInfo = (stateAuth) => {
  return {
    type: USER_INFO,
    payload: {
      request: {
        baseURL: config.api.baseUrl,
        url: 'user',
        method: 'get',
        headers: {
          Authorization: 'Bearer ' + stateAuth.accessToken,
        },
      },
    },
  };
};
